import { Helmet } from 'react-helmet';
import { useEffect } from 'react';


export const PageDocsEcommerceDev = () => {
  useEffect(() => {
    window.location.href = 'https://developers.google.com/analytics/devguides/collection/ga4/reference/events'
  }, [])

  return (
    <>
      <Helmet>
        <title>고객을 끌어오는 구글 애널리틱스4</title>
      </Helmet>
      <div>

      </div>
    </>
  )
}
